<template>
  <div class="loading" v-show="loading_state">
    <a-spin size="large" :tip="loading_text">
    </a-spin>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: mapState(['loading_state', 'loading_text'])
}
</script>

<style lang="scss">
@import "../style/mixin";
.loading {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 9999;
  background-color: rgba(255, 255, 255, 0.3);
  .ant-spin {
    @include center;
    .spin-content {
      padding: 30px;
    }
  }
}
</style>
